var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconThankYou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_63893)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 0C25.5609 0 0 25.5609 0 57C0 88.4391 25.5609 114 57 114C88.4391 114 114 88.4391 114 57C114 25.5609 88.4391 0 57 0Z",
    fill: "#4BAE4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5648 37.7848C85.9453 39.1652 85.9453 41.4363 84.5648 42.8168L51.1664 76.2152C50.4761 76.9055 49.5633 77.2617 48.6504 77.2617C47.7375 77.2617 46.8246 76.9055 46.1344 76.2152L29.4351 59.516C28.0547 58.1356 28.0547 55.8645 29.4351 54.484C30.8156 53.1035 33.0867 53.1035 34.4672 54.484L48.6504 68.6672L79.5328 37.7848C80.9133 36.382 83.1843 36.382 84.5648 37.7848Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_63893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 114,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThankYou);
export default __webpack_public_path__ + "static/media/icon_thank_you.08bb20ed3c779fd1db265f272fd85780.svg";
export { ForwardRef as ReactComponent };